module.exports = __webpack_public_path__ + "img/image.94a451c0.png";